import { useForm } from 'react-hook-form'

import { ChargePoint } from '../redux/api/web-api'

export interface IChargerInformationFormInput {
    name?: string | null
    description?: string | null
    partnerDescription?: string | null
    pool: string | null | undefined
    externalServerId?: number | null
    hardwareVersionId?: number
    hasServiceAgreement?: boolean
    installationDate?: string | null
    statusIntervalId?: number
    allowConnectCurrent: boolean
    wifiSsid?: string | null
    wifiPassword?: string | null
    partnerAccessible?: boolean
    callbackEnabledApiCustomerId: number | null
    countrySettingsId?: number | null
    debugEnabled?: boolean
    ownerInfo_0?: string | null
    ownerInfo_1?: string | null
    ownerInfo_2?: string | null
    externalId_1?: string | null
    externalId_2?: string | null
}

export const сhargerInfoDefaultValues = (chargePoint: ChargePoint): IChargerInformationFormInput => {
    return {
        name: chargePoint.name,
        description: chargePoint.additionalInfo?.description,
        partnerDescription: chargePoint.additionalInfo?.partnerDescription,
        pool: chargePoint.poolId,
        externalServerId: chargePoint.additionalInfo?.externalServerId,
        allowConnectCurrent: chargePoint.additionalInfo?.allowConnectCurrent ?? false,
        callbackEnabledApiCustomerId: chargePoint.additionalInfo?.callbackEnabledApiCustomerId ?? null,
        wifiSsid: chargePoint.additionalInfo?.wifiSsid,
        wifiPassword: chargePoint.additionalInfo?.wifiPassword,
        hasServiceAgreement: chargePoint.additionalInfo?.hasServiceAgreement,
        partnerAccessible: chargePoint.additionalInfo?.partnerAccessible,
        installationDate:
            chargePoint.additionalInfo?.installationDate &&
            new Date(chargePoint.additionalInfo?.installationDate).toLocaleDateString('sv-SE').slice(0, 10), //sv-SE used to format as YYYY-MM-DD to work with other locales. https://stackoverflow.com/a/60368477
        ownerInfo_0: chargePoint.ownerId,
        ownerInfo_1: chargePoint?.connectors && chargePoint?.connectors[0].connectorUserId,
        ownerInfo_2:
            chargePoint?.connectors && chargePoint?.connectors.length > 1
                ? chargePoint?.connectors[1].connectorUserId
                : '',
        statusIntervalId: chargePoint.additionalInfo?.statusIntervalId,
        countrySettingsId: chargePoint.countrySettingsId,
        hardwareVersionId: chargePoint.hardwareVersionId,
        debugEnabled: chargePoint.debugEnabled,
        externalId_1: chargePoint?.connectors && chargePoint?.connectors[0].externalId,
        externalId_2:
            chargePoint?.connectors && chargePoint?.connectors.length > 1 ? chargePoint?.connectors[1].externalId : '',
    }
}

export const useChargerInfoValidation = (chargePoint: ChargePoint) => {
    const defaultValues = сhargerInfoDefaultValues(chargePoint)

    return useForm<IChargerInformationFormInput>({
        mode: 'onChange',
        reValidateMode: 'onChange',
        delayError: 500,
        defaultValues,
    })
}
